import { useHistory } from "react-router-dom";
import { usePunditUserContext } from "@circle-react/contexts";

export const useLinkToRoot = () => {
  const { currentCommunity } = usePunditUserContext();
  const history = useHistory();

  const goToCommunityRootPath = (post_login_redirect?: string | null) => {
    const isHomePageEnabled = currentCommunity?.home_page_enabled;
    const postLoginRedirectQueryParam = post_login_redirect
      ? `?post_login_redirect=${post_login_redirect}`
      : "";

    if (isHomePageEnabled) {
      return history.push(`/home${postLoginRedirectQueryParam}`);
    }
    // necessary because Rails layout won't refresh when router does
    window.location.href = `/${postLoginRedirectQueryParam}`;
  };

  const goToMessagesRootPath = () => history.push("/messages");

  return { goToCommunityRootPath, goToMessagesRootPath };
};
